/* Sense — réglages de conversion communs à tout le site : note Trustpilot à jour, livraison et parfums mini dans le panier,
   bandeau pour payer dans Safari depuis l'appli Snapchat, rappel du pack sur les fiches parfum. */
(() => {
  // Note Trustpilot : à changer ici quand elle bouge (fr.trustpilot.com/review/sense-fragrances.com)
  const TP = { score: '4,0', stars: 4, count: 92 };
  // Livraison (France et UE) : point relais offert dès 20 €, domicile dès 80 € — en centimes, comme le panier
  const RELAY = 2000, HOME = 8000;
  const PACK_URL = '/products/pack-parfums-3-5';
  const PACK_KEY = 'sense-pack:pack-parfums-3-5';
  const UNIT = 4999;

  const money = c => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(c / 100);
  const plain = html => { const d = document.createElement('div'); d.innerHTML = html; return d.textContent; };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z"/></svg>';
  const GIFT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7S10.5 3 8 4s1.5 3 4 3Zm0 0s1.5-4 4-3-1.5 3-4 3Z"/></svg>';
  const PHONE = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="2.5" width="12" height="19" rx="2.5"/><path d="M10.5 18.5h3"/></svg>';
  const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* ---------- Note Trustpilot (texte de la page pack, bloc « Avis clients », image des fiches) ---------- */
  function trustpilot() {
    const label = `${TP.score}/5 sur Trustpilot · ${TP.count} avis`;
    document.querySelectorAll('.sp-rating').forEach(el => {
      const t = [...el.childNodes].find(n => n.nodeType === 3 && /trustpilot/i.test(n.textContent));
      if (t && t.textContent !== label) t.textContent = label;
    });
    document.querySelectorAll('.sense-avis-score-number').forEach(el => { if (el.textContent !== TP.score) el.textContent = TP.score; });
    document.querySelectorAll('.sense-avis-count').forEach(el => { const t = `${TP.count} avis`; if (el.textContent !== t) el.textContent = t; });
    document.querySelectorAll('.sense-avis-stars').forEach(box => {
      [...box.children].forEach((s, i) => {
        if (s.className !== 'sense-avis-star') s.className = 'sense-avis-star';
        const bg = i < TP.stars ? '' : '#dcdce6';
        if (s.style.background !== bg) s.style.background = bg;
      });
    });
    // Image « 4,4/5 sur Trustpilot » des fiches parfum : remplacée par la vraie note
    document.querySelectorAll('img[src*="95_de_nos_clients_ressentent"]').forEach(img => {
      const div = document.createElement('div');
      div.className = 'sc-tp';
      div.innerHTML = `<span class="sc-tp__stars">${[0, 1, 2, 3, 4].map(i => `<i${i < TP.stars ? ' class="on"' : ''}>${STAR}</i>`).join('')}</span><span>${esc(label)}</span>`;
      img.replaceWith(div);
    });
  }

  /* ---------- Panier : barre de livraison en deux paliers ---------- */
  function shipping() {
    document.querySelectorAll('free-ship-progress-bar').forEach(el => {
      const bar = el.querySelector('[data-total-order]');
      if (!bar) return;
      const total = Number(bar.dataset.totalOrder) || 0;
      let msg, pct;
      if (total >= HOME) { msg = '<b>Livraison offerte</b> : point relais ou domicile'; pct = 100; }
      else if (total >= RELAY) { msg = `<b>Point relais offert</b><br>Plus que ${money(HOME - total)} pour la livraison à domicile offerte`; pct = total / HOME * 100; }
      else { msg = `Plus que <b>${money(RELAY - total)}</b> pour le point relais offert`; pct = total / RELAY * 100; }
      // Le thème réécrit son propre message après coup : on compare le texte affiché, pas un drapeau
      const m = el.querySelector('.progress-bar-message');
      if (m && m.textContent !== plain(msg)) m.innerHTML = msg;
      const w = `${Math.max(0, Math.min(100, pct)).toFixed(1)}%`;
      if (bar.style.getPropertyValue('--width') !== w) bar.style.setProperty('--width', w);
    });
  }

  /* ---------- Panier : les 2 parfums mini glissés dans chaque commande ---------- */
  function minis() {
    document.querySelectorAll('free-ship-progress-bar').forEach(el => {
      const bar = el.querySelector('[data-total-order]');
      const total = bar ? Number(bar.dataset.totalOrder) || 0 : 0;
      const next = el.nextElementSibling;
      const has = next && next.classList.contains('sc-minis-wrap');
      if (total <= 0) { if (has) next.remove(); return; }
      if (!has) el.insertAdjacentHTML('afterend', `<div class="sc-minis-wrap drawer-spacing"><div class="sc-minis">${GIFT}<span><b>2 parfums mini offerts</b> avec votre commande, pour tester nos best-sellers</span></div></div>`);
    });
  }

  /* ---------- Panier ouvert dans l'appli Snapchat (iPhone) : Apple Pay n'y apparaît pas ---------- */
  // ?sc_snap=1 dans l'adresse affiche le bandeau pour le tester sans l'appli
  const SNAP = (/Snapchat/i.test(navigator.userAgent) && /iPhone|iPad|iPod/i.test(navigator.userAgent)) || /[?&]sc_snap=1/.test(location.search);
  let snapBusy = false;
  async function snapBanner() {
    if (!SNAP || snapBusy) return;
    const bar = document.querySelector('cart-drawer free-ship-progress-bar');
    if (!bar || document.querySelector('cart-drawer .sc-snap-wrap')) return;
    snapBusy = true;
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      if (!cart.items || !cart.items.length || document.querySelector('cart-drawer .sc-snap-wrap')) return;
      // Lien panier Shopify : refait le même panier dans Safari et va droit au paiement (les remises automatiques s'appliquent)
      const qty = new Map();
      cart.items.forEach(i => qty.set(i.variant_id, (qty.get(i.variant_id) || 0) + i.quantity));
      const lines = [...qty].map(([id, q]) => `${id}:${q}`).join(',');
      const href = `x-safari-https://${location.host}/cart/${lines}`;
      bar.insertAdjacentHTML('beforebegin', `<div class="sc-snap-wrap drawer-spacing"><div class="sc-snap">
        <div class="sc-snap__head">${PHONE}<div><p class="sc-snap__title">Apple Pay n'est pas disponible dans l'appli Snapchat</p><p class="sc-snap__line">Ouvrez votre panier dans Safari pour payer en un geste.</p></div></div>
        <a class="sc-snap__btn" href="${esc(href)}">Ouvrir mon panier dans Safari ${ARROW}</a>
        <p class="sc-snap__note">Vous pouvez aussi payer ici par carte ou PayPal.</p>
      </div></div>`);
    } catch (e) {} finally { snapBusy = false; }
  }

  /* ---------- Fiche parfum : rappel du pack, avec le nom du parfum ---------- */
  function packPromo() {
    if (!/\/products\//.test(location.pathname) || /\/products\/pack-/.test(location.pathname) || document.querySelector('.sc-promo')) return;
    const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (!meta || !Array.isArray(meta.variants) || !meta.variants.length) return;
    const field = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const v = meta.variants.find(x => field && String(x.id) === String(field.value)) || meta.variants[0];
    // Pas sur les parfums mini (2 ml)
    if (/mini|\b2\s?ml\b/i.test(`${v.public_title || ''} ${v.name || ''}`)) return;
    const titleEl = document.querySelector('.block-product__title');
    const name = titleEl ? titleEl.textContent.trim() : '';
    const price = Number(v.price) || 0;
    if (!name || !price) return;
    const priceBlock = [...document.querySelectorAll('.shopify-block')].find(b => /prix en boutique de luxe/i.test(b.textContent));
    const anchor = priceBlock || document.querySelector('.block-product__buttons');
    if (!anchor) return;
    // Pack 3+1 avec ce parfum et 3 parfums au prix habituel : le moins cher est offert
    const per = Math.floor((price + 3 * UNIT - Math.min(price, UNIT)) / 4);
    const html = `<div class="sc-promo">
      <span class="sc-promo__icon">${GIFT}</span>
      <div class="sc-promo__text">
        <p class="sc-promo__title">Encore moins cher en pack</p>
        <p class="sc-promo__line">${esc(name)} + 3 parfums au choix, le 4e offert : <b>dès ${money(per)} le parfum</b></p>
        <a class="sc-promo__link" href="${PACK_URL}" data-sc-pack="${v.id}">Composer mon pack avec ${esc(name)} ${ARROW}</a>
      </div>
    </div>`;
    anchor.insertAdjacentHTML(priceBlock ? 'afterend' : 'beforebegin', html);
  }
  // Le pack s'ouvre avec ce parfum déjà choisi (la page pack relit cette sélection)
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-sc-pack]');
    if (!a) return;
    try {
      const s = JSON.parse(localStorage.getItem(PACK_KEY) || 'null') || {};
      const size = Number(s.size) || 4;
      const picks = Array.isArray(s.picks) ? s.picks.map(Number) : [];
      const id = Number(a.dataset.scPack);
      if (!picks.includes(id) && picks.length < size) picks.push(id);
      localStorage.setItem(PACK_KEY, JSON.stringify({ size, picks }));
    } catch (err) {}
  });

  /* ---------- Démarrage, puis à chaque fois que le thème redessine le panier ---------- */
  let queued = false;
  const run = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      trustpilot();
      shipping();
      minis();
      snapBanner();
    });
  };
  const start = () => {
    run();
    packPromo();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();